export default __webpack_public_path__ + "static/media/Element-7.7c9d9535.png";